import request from '@/utils/request'
import type { SysDictionary, SysDictionaryItem } from '@/types/entities'

export function getDictionaries(): Promise<SysDictionary[]> {
  return request({
    url: '/api/dictionaries',
    method: 'get'
  }) as Promise<SysDictionary[]>
}

export function getDictionaryItems(code: string): Promise<SysDictionaryItem[]> {
  return request({
    url: `/api/dictionaries/${code}/items`,
    method: 'get'
  }) as Promise<SysDictionaryItem[]>
}

export function createDictionary(data: Omit<SysDictionary, 'id'>): Promise<SysDictionary> {
  return request({
    url: '/api/dictionaries',
    method: 'post',
    data
  }) as Promise<SysDictionary>
}

export function updateDictionary(id: number, data: Partial<SysDictionary>): Promise<SysDictionary> {
  return request({
    url: `/api/dictionaries/${id}`,
    method: 'put',
    data
  }) as Promise<SysDictionary>
}

export function deleteDictionary(id: number): Promise<void> {
  return request({
    url: `/api/dictionaries/${id}`,
    method: 'delete'
  }) as Promise<void>
}

export function createDictionaryItem(dictionaryId: number, data: Omit<SysDictionaryItem, 'id' | 'dictionaryId'>): Promise<SysDictionaryItem> {
  return request({
    url: `/api/dictionaries/${dictionaryId}/items`,
    method: 'post',
    data
  }) as Promise<SysDictionaryItem>
}

export function updateDictionaryItem(id: number, data: Partial<SysDictionaryItem>): Promise<SysDictionaryItem> {
  return request({
    url: `/api/dictionaries/items/${id}`,
    method: 'put',
    data
  }) as Promise<SysDictionaryItem>
}

export function deleteDictionaryItem(id: number): Promise<void> {
  return request({
    url: `/api/dictionaries/items/${id}`,
    method: 'delete'
  }) as Promise<void>
}
